import { render, staticRenderFns } from "./SeminarEntryMessageHistory.vue?vue&type=template&id=68986c67"
import script from "./SeminarEntryMessageHistory.vue?vue&type=script&lang=js"
export * from "./SeminarEntryMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports